import { css } from "@compiled/react";

import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    ReturnToProductSubheading,
    WelcomeBackHeading
} from "../../../components";

export const CurrentProductUser = () => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const version = modalVisualUpdates ? LayoutVersion.V3 : LayoutVersion.V1;

    return (
        <JiraOverlayTemplate size="sm" version={version}>
            <div css={containerCss}>
                <WelcomeBackHeading />
                <ReturnToProductSubheading />
                <SiteActivation
                    CurrentProductUser={<ReturnToProduct />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </JiraOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
